import styled from '@emotion/styled';
import { useTranslate } from '@integration-frontends/core/translation/use-translate';
import { lodestarColors } from '@smartsheet/design-tokens';
import React, { FunctionComponent } from 'react';
import { RibbonContainerBase, ThumbnailStatusRibbonProps } from './common';

export const ThumbnailStatusRibbonSmartsheet: FunctionComponent<ThumbnailStatusRibbonProps> = ({
  asset,
}) => {
  const { translate } = useTranslate();

  switch (asset?.availability) {
    case 'expired':
      return <RibbonContainer>{translate('Expired')}</RibbonContainer>;
    case 'unpublished':
      return <RibbonContainer>{translate('Draft')}</RibbonContainer>;
    case 'pending_approval':
      return <RibbonContainer>{translate('Pending')}</RibbonContainer>;
    default:
      return null;
  }
};

const RibbonContainer = styled(RibbonContainerBase)`
  color: ${lodestarColors.neutralLight40};
  border-bottom-color: ${lodestarColors.danger};
`;
